import { createSelector } from 'reselect'
import { RootState } from '../store'

import { SOCIAL_NETWORK } from '../models/post'
import {
  TProjectSocialFacebook,
  TProjectSocialInstagram,
  TProjectSocialLinkedin,
  TProjectSocialTwitter
} from '../store/project/types'
import { OriginalSocialIcons } from '../components/UI/Icons/socials'
import React from 'react'

const socialMediaData = (state: RootState) => state.project.currentProject.socials

export const selectSocialMediaDataBySocialName = createSelector(
  socialMediaData,
  (connectedSocials) =>
    Object.values(SOCIAL_NETWORK).reduce(
      (accumulator: TSocialDetails, socialNetwork) => {
        const connectedSocial = connectedSocials.find(
          (connectedSocial) => connectedSocial.social_network === socialNetwork
        )

        switch (socialNetwork) {
          case SOCIAL_NETWORK.FACEBOOK_SOCIAL: {
            const social = connectedSocial as TProjectSocialFacebook | null

            accumulator[socialNetwork] = {
              logo: {
                ...accumulator[socialNetwork].logo,
                original: social?.logo
              },
              name: social?.account_details.fb_page_name || socialNetwork
            }
            break
          }

          case SOCIAL_NETWORK.INSTAGRAM_SOCIAL: {
            const social = connectedSocial as TProjectSocialInstagram | null

            accumulator[socialNetwork] = {
              logo: {
                ...accumulator[socialNetwork].logo,
                original: social?.logo
              },
              name: social?.account_details.fb_page_name || socialNetwork
            }
            break
          }

          case SOCIAL_NETWORK.LINKEDIN_SOCIAL: {
            const social = connectedSocial as TProjectSocialLinkedin | null

            accumulator[socialNetwork] = {
              logo: {
                ...accumulator[socialNetwork].logo,
                original: social?.logo
              },
              name: social?.account_details.organizationName || socialNetwork
            }
            break
          }

          case SOCIAL_NETWORK.TWITTER_SOCIAL: {
            const social = connectedSocial as TProjectSocialTwitter | null

            accumulator[socialNetwork] = {
              logo: {
                ...accumulator[socialNetwork].logo,
                original: social?.logo
              },
              name: social?.account_details.screen_name || socialNetwork
            }
            break
          }
        }

        return accumulator
      },
      {
        [SOCIAL_NETWORK.FACEBOOK_SOCIAL]: {
          logo: {
            original: '',
            default: OriginalSocialIcons[SOCIAL_NETWORK.FACEBOOK_SOCIAL]
          },
          name: ''
        },
        [SOCIAL_NETWORK.INSTAGRAM_SOCIAL]: {
          logo: {
            original: '',
            default: OriginalSocialIcons[SOCIAL_NETWORK.INSTAGRAM_SOCIAL]
          },
          name: ''
        },
        [SOCIAL_NETWORK.LINKEDIN_SOCIAL]: {
          logo: {
            original: '',
            default: OriginalSocialIcons[SOCIAL_NETWORK.LINKEDIN_SOCIAL]
          },
          name: ''
        },
        [SOCIAL_NETWORK.TWITTER_SOCIAL]: {
          logo: {
            original: '',
            default: OriginalSocialIcons[SOCIAL_NETWORK.TWITTER_SOCIAL]
          },
          name: ''
        }
      }
    )
)

export type TSocialDetails = {
  [key in SOCIAL_NETWORK]: {
    logo: TAccountLogo
    name: string
  }
}

export type TAccountLogo = {
  original: string | undefined
  default: React.ReactElement
}
